import { Search } from "@mui/icons-material";
import { InputAdornment, Select as MuiSelect, TextField as MuiTextField, Stack, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const ChannelActions = ({ onSearchChange }) => {
  const { t: getLabel } = useTranslation();

  const handleChangeKeyword = event => {
    const keyword = event.target.value;
    onSearchChange(keyword);
  };

  return (
    <Stack direction="row" spacing={1}>
      <TextField
        name="keyword"
        placeholder={getLabel("TXT_SEARCH_CHANNEL_PLACEHOLDER")}
        size="small"
        onChange={handleChangeKeyword}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </Stack>
  );
};

export default ChannelActions;

const TextField = styled(MuiTextField)({
  maxWidth: 800,
  flex: 1,
});

const Select = styled(MuiSelect)({
  width: 200,
});
